import { Box, Button, styledComponent, FormLabel } from '@hermes/web-components'

export const ListContainer = styledComponent(Box)(() => ({}))

export const ListItemContainer = styledComponent(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  padding: '12px 0 12px 8px',
  marginLeft: '8px',
  borderBottom: `1px solid ${theme.palette.neutral[200]}`,

  ':last-child': {
    borderBottom: '0px'
  }
}))

export const ModalButton = styledComponent(Button)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.neutral[200]}`,

  ':disabled': {
    borderTop: `1px solid ${theme.palette.neutral[200]}`
  }
}))

export const Label = styledComponent(FormLabel)(({ theme }) => ({
  marginTop: '20px',
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '16px',
  color: theme.palette.neutral.main
}))
